import { render, staticRenderFns } from "./TimelineTag.vue?vue&type=template&id=1f353841&scoped=true"
import script from "./TimelineTag.vue?vue&type=script&lang=js"
export * from "./TimelineTag.vue?vue&type=script&lang=js"
import style0 from "./TimelineTag.vue?vue&type=style&index=0&id=1f353841&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f353841",
  null
  
)

export default component.exports